// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form___aCZp","perdeu":"LoginForm_perdeu__1Scbt","cadastro":"LoginForm_cadastro__1DJUy","subtitle":"LoginForm_subtitle__2t_1t"};